module.exports = __webpack_public_path__ + "static/media/solarin_362_362.245b7d64.png";